import { render } from "./SuPompasi.vue?vue&type=template&id=3af99ff4"
import script from "./SuPompasi.vue?vue&type=script&lang=js"
export * from "./SuPompasi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__